const calendarLink = document.querySelector("#generated-calendar-invite");

calendarLink.addEventListener("click", calendarLinkClick, false);

function calendarLinkClick(event) {
	let warn = "preventDefault() won't let you check this!<br>";
	console.log(warn);
	event.preventDefault();
	console.log(this.dataset);
	let courseID = this.dataset.courseid,
		feedTitle = this.dataset.feedtitle,
		alertMinutes = this.dataset.alertminutes,
		useOn24Link = this.dataset.on24link;
	lessonsIDs = this.dataset.lessons;
	locationText = this.dataset.locationtext;
	searchType = this.dataset.searchType;

	makeRequest(courseID, feedTitle, alertMinutes, searchType);
	function makeRequest(courseID, feedTitle, alertMinutes, searchType) {
		httpRequest = new XMLHttpRequest();

		if (!httpRequest) {
			alert("Giving up :( Cannot create an XMLHTTP instance");
			return false;
		}
		let postObj = {
			courseID: courseID,
			feedTitle: feedTitle,
			alertMinutes: alertMinutes,
			On24Link: useOn24Link,
			lessonIDs: lessonsIDs,
			locationText: locationText,
			searchType: searchType,
		};
		let post = JSON.stringify(postObj);
		const url =
			"/wp-content/plugins/ria-channel-custom-lms-wordpress-blocks/includes/cal-invite-generator-script.php";
		let xhr = new XMLHttpRequest();
		xhr.open("POST", url, true);
		xhr.setRequestHeader("Content-type", "application/json; charset=UTF-8");
		xhr.onreadystatechange = function () {
			if (xhr.readyState === 4 && xhr.status === 200) {
				console.log(xhr.responseText);
				var blob = new Blob([xhr.responseText], { type: "text/calendar" });
				var link = document.createElement("a");
				link.href = window.URL.createObjectURL(blob);
				link.download = feedTitle + ".ics";
				link.click();
			}
		};
		xhr.send(post);
	}

	function alertContents() {
		if (httpRequest.readyState === XMLHttpRequest.DONE) {
			if (httpRequest.status === 200) {
				alert(httpRequest.responseText);
			} else {
				alert("There was a problem with the request.");
			}
		}
	}
}
